<template>
  <div v-if="!_product">
    <product-detail-desk-loader v-if="$vuetify.breakpoint.mdAndUp"></product-detail-desk-loader>
    <product-detail-mobile-loader v-else></product-detail-mobile-loader>
  </div>
  <div v-else>
    <product-detail-desk @add="addToCart" v-if="$vuetify.breakpoint.mdAndUp"></product-detail-desk>
    <product-detail-mobile @add="addToCart" v-else></product-detail-mobile>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import navigationMixin from '@/mixins/navigation'
import ProductDetailDesk from '@/components/Product/ProductDetailDesk'
import ProductDetailMobile from '@/components/Product/ProductDetailMobile'
import ProductDetailDeskLoader from '@/loaders/ProductDetailDeskLoader'
import ProductDetailMobileLoader from '@/loaders/ProductDetailMobileLoader'

export default {
  name: 'ProductDetail',
  mixins: [navigationMixin],
  components: {
    ProductDetailDesk,
    ProductDetailMobile,
    ProductDetailDeskLoader,
    ProductDetailMobileLoader
  },
  computed: {
    ...mapState('product', ['_product'])
  },
  methods: {
    ...mapActions('product', ['getProduct']),
    ...mapMutations('cart', ['addProduct']),
    ...mapMutations('shipping', ['setShippingInfo']),
    addToCart (products) {
      for (const product of products) {
        this.addProduct(product)
        // eslint-disable-next-line
        fbq('track', 'AddToCart')
      }

      this.$emit('notificationPopup', { y: 'bottom', x: 'left', timeout: 5000, icon: 'add_shopping_cart', color: 'success', message: 'Producto agregado al carrito exitosamente' })
    }
  },
  async mounted () {
    await this.getProduct(this.$route.params.slug)
    // eslint-disable-next-line
    fbq('track', 'ViewContent')
  },
  destroyed () {
    this.setShippingInfo(null)
  }
}
</script>
